// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var VolumeMode;
(function (VolumeMode) {
    VolumeMode[VolumeMode["Delta"] = 0] = "Delta";
    VolumeMode[VolumeMode["DeltaPercent"] = 1] = "DeltaPercent";
    VolumeMode[VolumeMode["TotalVolume"] = 2] = "TotalVolume";
    VolumeMode[VolumeMode["BuyVolume"] = 3] = "BuyVolume";
    VolumeMode[VolumeMode["SellVolume"] = 4] = "SellVolume";
    VolumeMode[VolumeMode["AverageTotalSize"] = 5] = "AverageTotalSize";
    VolumeMode[VolumeMode["AverageBuySize"] = 6] = "AverageBuySize";
    VolumeMode[VolumeMode["AverageSellSize"] = 7] = "AverageSellSize";
    VolumeMode[VolumeMode["CustomTotalVolumePercent"] = 8] = "CustomTotalVolumePercent";
    VolumeMode[VolumeMode["CustomBuyVolumePercent"] = 9] = "CustomBuyVolumePercent";
    VolumeMode[VolumeMode["CustomSellVolumePercent"] = 10] = "CustomSellVolumePercent";
    VolumeMode[VolumeMode["Trades"] = 11] = "Trades";
    VolumeMode[VolumeMode["OpenInterest"] = 12] = "OpenInterest";
    VolumeMode[VolumeMode["BuyVolumePercent"] = 13] = "BuyVolumePercent";
    VolumeMode[VolumeMode["SellVolumePercent"] = 14] = "SellVolumePercent";
    VolumeMode[VolumeMode["MaxTickVolume"] = 15] = "MaxTickVolume";
    VolumeMode[VolumeMode["LevelVolumePercent"] = 16] = "LevelVolumePercent";
    VolumeMode[VolumeMode["LevelDeltaPercent"] = 17] = "LevelDeltaPercent";
    VolumeMode[VolumeMode["CustomPair"] = 18] = "CustomPair";
    VolumeMode[VolumeMode["BuySell"] = 19] = "BuySell";
    VolumeMode[VolumeMode["VolumeImbalance"] = 20] = "VolumeImbalance";
})(VolumeMode || (VolumeMode = {}));
export var VolumeColoringMode;
(function (VolumeColoringMode) {
    VolumeColoringMode[VolumeColoringMode["Fixed"] = 1] = "Fixed";
    VolumeColoringMode[VolumeColoringMode["ByBar"] = 2] = "ByBar";
    VolumeColoringMode[VolumeColoringMode["ByDifference"] = 3] = "ByDifference";
    VolumeColoringMode[VolumeColoringMode["ByMovingAverage"] = 4] = "ByMovingAverage";
})(VolumeColoringMode || (VolumeColoringMode = {}));
export function getVolumeColoringModeKey(value) {
    switch (value) {
        case VolumeColoringMode.Fixed:
            return 'chart.volumeColoringMode.Fixed';
        case VolumeColoringMode.ByBar:
            return 'chart.volumeColoringMode.ByBar';
        case VolumeColoringMode.ByDifference:
            return 'chart.volumeColoringMode.ByDifference';
        case VolumeColoringMode.ByMovingAverage:
            return 'chart.volumeColoringMode.ByMovingAverage';
        default:
            return '';
    }
}
export function getVolumeColoringModeTooltipKey(value) {
    switch (value) {
        case VolumeColoringMode.Fixed:
            return 'property.VolumeBars.Fixed.Tooltip';
        case VolumeColoringMode.ByBar:
            return 'property.VolumeBars.ByBar.Tooltip';
        case VolumeColoringMode.ByDifference:
            return 'property.VolumeBars.ByDifference.Tooltip';
        case VolumeColoringMode.ByMovingAverage:
            return 'property.VolumeBars.AboveBelowMovingAverage.Tooltip';
        default:
            return '';
    }
}
export const VolumeHistoryMode = {
    Trades: 0,
    Ticks: 1
};
